import axios from "axios";
import React, {useEffect, useState} from "react";
import {DataGrid, GridToolbar} from "@mui/x-data-grid";
import {baseUrl, formatDateTime} from "./Univ";
function SystemAlerts() {
    const [alerts, setAlerts] = useState([])
    const [rows, setRows] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    useEffect(() => {
        fetchAlerts()
        markAlertsRead()
    }, [])
    useEffect(() => {
        if (alerts.length > 0) {
            setRows(alerts)
        }
    }, [alerts])
    function fetchAlerts() {
        setIsLoading(true)
        axios.get(baseUrl + "alerts-view/")
            .then(response => {
                setAlerts(response.data)
                setIsLoading(false)
            })
            .catch(error => {
                console.log(error)
                setIsLoading(false)
            })
    }
    function markAlertsRead() {
        axios.post(baseUrl + "alerts-read/")
            .then(() => {
                console.log("alerts marked read")
            })
    }
    const columns = [
        {field: 'id', headerName: 'ID', width: 80},
        {field: 'alert_type', headerName: 'Type', width: 120},
        {field: 'message', headerName: 'Message', width: 500},
        {
            field: 'created_at',
            headerName: 'Date',
            width: 220,
            renderCell: (params) => (
                <span>{formatDateTime(params.row.created_at)}</span>
            )
        },
        {field: 'addedby', headerName: 'Added By', width: 150},
        {
            field: 'is_read',
            headerName: 'Status',
            width: 120,
            renderCell: (params) => (
                <span>
{params.row.is_read ? "Read" : "Unread"}
</span>
            )
        }
    ]
    return (
        <section className="container mt-4">

            <h4 className="mb-3">System Alerts</h4>

            <div style={{height: "100%", width: "100%"}}>

                <DataGrid
                    sx={{
                        boxShadow: 4,
                        border: 4,
                        borderColor: 'primary.light',
                        '& .MuiDataGrid-cell:hover': {
                            color: 'primary.main',
                        },
                    }}

                    rows={rows}
                    columns={columns}
                    loading={isLoading}
                    pageSize={25}
                    autoHeight
                    components={{
                        Toolbar: GridToolbar
                    }}
                />

            </div>

        </section>
    )
}
export default SystemAlerts